<template>
  <div class="box">
    <div class="image-types" @click="uploadShow = true">
      <img v-if="data.images" :src="data.images" alt="">
      <img v-else src="../../assets/image-upload.jpg" alt="">
      <el-button v-if="data.images" class="del_Btn" type="danger" size="small" icon="el-icon-delete" circle
        @click="handleDel"></el-button>
    </div>

    <div>
      <span>链接：</span>
      <el-dropdown @command="handleLinkItem">
        <span class="el-dropdown-link">
          {{ data.link }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx" :command="`${link.title}#${link.page}`">
            {{ link.title }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>
<script>
import imgPre from '../../components/uploadImg/imgPre'
export default {
  name: 'ImageSetting',
  components: { imgPre },
  props: {
    data: Object
  },
  data () {
    return {
      uploadShow: false
    }
  },
  methods: {
    handleClick: function (type) {
      this.data.imageType = type
    },
    handleImg: function (data) {
      this.data.images = data.url
      this.uploadShow = false
    },
    handleDel: function (e) {
      e.stopPropagation()
      this.data.images = ''
    },
    handleLinkItem (command) {
      const idx1 = command.indexOf('#')
      const pagetit = command.substring(0, idx1)
      const page = command.substring(idx1 + 1)
      this.data.link = pagetit
      this.data.page = page
    }
  }
}
</script>
<style scoped>
.box {
  padding: 20px 30px;
}

.image-types {
  position: relative;
  display: flex;
  justify-content: center;
  height: 200px;
  border: 1px solid #f3f3f3;
  border-radius: 12px;
  cursor: pointer;
}

.image-types .del_Btn {
  position: absolute;
  top: 6px;
  right: 6px;
  display: none;
}

.image-types:hover .del_Btn {
  display: block;
  z-index: 1;
}

.image-types:hover::after {
  content: "点击上传";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  text-align: center;
  line-height: 200px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  border-radius: 12px;
}

.image-types img {
  width: 100%;
  border-radius: 12px;
}

.title {
  font-size: 13px;
}

.title h4 {
  display: inline;
  font-size: 14px;
}

.title .desc {
  font-size: 12px;
  color: #687382;
}

.image-type {
  float: left;
  width: 82px;
  height: 82px;
  margin: 18px;
  font-size: 12px;
  text-align: center;
  color: #687382;
  border: 1px solid white;
  cursor: pointer;
}

.image-type.active {
  border: 1px solid #7fc0f6;
}

.image-type:first-child {
  margin-left: 0;
}

.image-type:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/image/ImageSetting.vue